"use client";

import { cn } from "@/lib/utils";
import React from "react";
import GlobalSearchStandalone from "../global-search/GlobalSearchStandalone";
import { useCoveoContext } from "../../../providers/CoveoProvider";
import { usePublicConfigContext } from "../../../providers/PublicConfigProvider";
import { CartStatus } from "./CartStatus";
import { FeaturedLinks } from "./FeaturedLinks";
import { LocalizationNavbarMenu } from "./LocalizationNavbarMenu";
import { UserMenu } from "./UserMenu";

export const UtilityLinks = ({
  className,
}: {
  readonly className?: string;
}) => {
  const { COVEO_ORGANIZATION_ID } = usePublicConfigContext();
  const { jwtCreateGlobalSearch, jwtRenewGlobalSearch } = useCoveoContext();

  const globalSearchAccessToken =
    jwtCreateGlobalSearch.data?.coveoJwtCreate.jwt;

  return (
    <div className={cn("flex items-center gap-md xl:gap-xl", className)}>
      <div className="flex items-center gap-xs">
        {COVEO_ORGANIZATION_ID && globalSearchAccessToken ? (
          <GlobalSearchStandalone
            accessToken={globalSearchAccessToken}
            organizationId={COVEO_ORGANIZATION_ID}
            variant="popover"
            jwtRenewGlobalSearch={jwtRenewGlobalSearch}
            popoverContentClassName="max-lg:hidden"
          />
        ) : (
          // placeholder to avoid horizontal layout shift (40px = 20px icon + 20px padding)
          <div className="w-5xl shrink-0" aria-hidden />
        )}

        <CartStatus />

        <UserMenu />

        <LocalizationNavbarMenu />
      </div>

      <FeaturedLinks />
    </div>
  );
};
